import React, {useEffect, useRef } from "react";
import DynamicForm from "../stories/Forms/DynamicForm";
import { useNavigate, useParams } from "react-router";
import { resetPasswordFields } from "../stories/Forms/fields";
import { resetPasswordSchema } from "../stories/Forms/validationSchema";
import Invalid from "../stories/utils/Invalid";
import useApis from "../services/useAPI";
import { useAuth } from "../components/AuthContext/AuthContext";
import { Button } from "../stories/Buttons/Button";
import { logoutUrl, resetPasswordUrl } from "../utils/constants";
import logo from "../assets/images/boots-myhealthchecked-logo.svg";
import LoggedOutLayout from "../stories/LoggedOutScreens/LoggedOutLayout";
import { XCircleFill } from "react-bootstrap-icons";

function ResetPassword() {
  const { id, uuid } = useParams();
  const url = `${resetPasswordUrl}/${uuid}/${id}/`;

  const navigate = useNavigate();
  const auth = useAuth();

  useEffect(() => {
    auth.setTitle("Reset password");
  }, [auth.title]);

  const { callApi, serverError, message } =
    useApis(url, "POST");

  // Fetch initial data using GET request when id changes
  useEffect(() => {
    const fetch = async () => {
      callApi("", url, "GET");
    };
    fetch();
  }, [id]);

  // Handle form submission
  const handleSubmit = async (data) => {
    callApi(data);
  };

  const hasHandledReset = useRef(false);

  useEffect(() => {
    if (
      message?.postMessage === "Password reset successfully" &&
      !hasHandledReset.current
    ) {
      hasHandledReset.current = true;

      auth.showToast(
        "Success",
        "Password has been reset successfully!",
        undefined,
        {icon: undefined,
        className: auth?.featureFlag && "vh-toaster"}
      );

      auth.logout();
      callApi(null, logoutUrl, "POST");
      navigate("/login");
    }
  }, [message?.postMessage, auth, callApi, navigate]);

  // Surface SSO-blocked (and other) reset-password errors as a toast,
  // mirroring LoginForm's serverError handling.
  useEffect(() => {
    if (serverError) {
      auth?.showToast("Error", serverError, "../assets/mhc.png", {
        icon: <XCircleFill />,
        className: auth?.featureFlag && "vh-toaster",
      });
    }
  }, [serverError]);

  const renderContent = () => {
    if (message.getMessage === "This link has expired" || 
        (message.getMessage !== "Token is valid" && message.getMessage !== "This link has expired")) {
      return (
        <div className="text-center back-to-login">
          <Invalid message={serverError} />
          <Button
            className={"mt-4"}
            href="/login"
            label={"Back to Login"}
            variant={"danger"}
          />
        </div>
      );
    }
    return (
      <DynamicForm
        fields={resetPasswordFields}
        onSubmit={handleSubmit}
        serverError={serverError}
        validationSchema={resetPasswordSchema}
      />
    );
  };

  return (
    <LoggedOutLayout
      className={
        auth.title === "Access dashboard"
          ? "login-bg login-page-container "
          : ""
      }
      logoSrc={logo}
      title={auth.title}
    >
      {renderContent()}
    </LoggedOutLayout>
  );
}

export default ResetPassword;
